import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text: string;
  subtext?: string;
  color?: 'green' | 'red';
  className?: string;
}
export function CTAButton({
  text,
  subtext,
  color = 'green',
  className = ''
}: CTAButtonProps) {
  const bgColor = color === 'green' ? 'bg-brand-green hover:bg-green-600' : 'bg-brand-red hover:bg-red-700';
  return <motion.a href="https://impulsodigital.vip/cart/44763616936022:1" className={`block w-full max-w-xl mx-auto text-center rounded-xl shadow-[0_8px_0_rgb(0,0,0,0.2)] active:shadow-[0_0px_0_rgb(0,0,0,0.2)] active:translate-y-2 transition-all duration-150 ${bgColor} text-white p-4 sm:p-6 ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} animate={{
    scale: [1, 1.02, 1]
  }} transition={{
    duration: 2,
    repeat: Infinity,
    repeatType: 'reverse'
  }} data-id="element-70">
      <span className="block font-archivo text-2xl sm:text-3xl md:text-4xl uppercase tracking-wide text-shadow-sm" data-id="element-71">
        {text}
      </span>
      {subtext && <span className="block mt-2 font-inter font-semibold text-sm sm:text-base opacity-90" data-id="element-72">
          {subtext}
        </span>}
    </motion.a>;
}